import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuperAdminService } from '../super-admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-super-admin-filter-dialog',
  templateUrl: './super-admin-filter-dialog.component.html',
  styleUrls: ['./super-admin-filter-dialog.component.scss']
})
export class SuperAdminFilterDialogComponent implements OnInit {
  stateDetails: any;
  zoneDetails: any;
  cityDetails: any;
  campusDetails: any;
  buildingDetails: any;


  stateQuery: string = '';
  zoneQuery: string = '';
  cityQuery: string = '';
  campusQuery: string = '';
  buildingQuery: string = '';




  stateValue: any;
  zoneValue: any;
  cityValue: any;
  campusValue: any;
  buildingValue: any;



  filteredStateDetails: any;
  filteredZoneDetails: any;
  filteredcityDetails: any;
  filteredcampusDetails: any;
  filteredbuildingDetails: any;



  selectedStateName: any;
  selectedStateID: any;

  selectedzoneName: any;

  selectedcityName: any;
  selectedcityId: any;

  selectedcampusName: any;
  selectedcampusId: any;

  Datapassing: any;

  @ViewChild('searchInputstate') searchInputstate!: ElementRef;
  @ViewChild('searchInputzone') searchInputzone!: ElementRef;
  @ViewChild('searchInputcity') searchInputcity!: ElementRef;
  @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;



  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<SuperAdminFilterDialogComponent>, private service: SuperAdminService, private spinner: NgxSpinnerService, private toast: ToastmessageService,) { }
  ngOnInit(): void {
    this.onState();
  }

  onState() {
    this.spinner.show();
    this.service.getState().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.stateDetails = res;
        this.stateQuery = '';
        this.filteredStateDetails = this.stateDetails;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    });
  }
  // focus//
  focusSearchInput() {
    setTimeout(() => {
      if (this.searchInputstate) {
        this.searchInputstate.nativeElement.focus();
      }
    }, 100);
  }

  focusSearchzoneInput() {
    setTimeout(() => {
      if (this.searchInputzone) {
        this.searchInputzone.nativeElement.focus();
      }
    }, 100);
  }

  focusSearchcityInput() {
    setTimeout(() => {
      if (this.searchInputcity) {
        this.searchInputcity.nativeElement.focus();
      }
    }, 100);
  }

  focusSearchcampusInput() {
    setTimeout(() => {
      if (this.searchInputcampus) {
        this.searchInputcampus.nativeElement.focus();
      }
    }, 100);
  }


  // End focus//

  // selected input //
  selectState(stateName: any, stateId: any): void {
    this.filteredStateDetails = this.stateDetails;
    this.selectedStateName = stateName;
    this.selectedStateID = stateId;
    this.stateQuery = '';
    this.onSelectedZone();
  }
  selectZone(zoneName: any) {
    this.filteredZoneDetails = this.zoneDetails;
    this.selectedzoneName = zoneName;
    this.zoneQuery = '';
    this.onSelectedCity();
  }
  selectCity(cityName: any, cityId: any) {
    this.filteredcityDetails = this.cityDetails;
    this.selectedcityName = cityName;
    this.selectedcityId = cityId;
    this.cityQuery = '';
    this.onSelectedCampus();
  }

  selectCampus(campusName: any, campusId: any) {
    this.filteredcampusDetails = this.campusDetails;
    this.selectedcampusName = campusName;
    this.selectedcampusId = campusId;
    // console.log('selectedcampusId', this.selectedcampusId);

    this.campusQuery = '';
    // this.onSelectedBuilding();
  }

  // selectbuilding(buildingName: any, buildingId: any) {
  //   this.filteredbuildingDetails = this.buildingDetails;
  //   this.selectedbuildingName = buildingName;
  //   this.selectedbuildingId = buildingId;
  //   this.buildingQuery = '';
  // }

  //End selected input //

  onSelectedZone() {
    this.spinner.show();
    this.service.getStateZone(this.selectedStateID).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        console.log('res', res);
        this.zoneDetails = res;
        this.zoneQuery = '';
        this.selectedzoneName = ''
        this.filteredZoneDetails = this.zoneDetails;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  onSelectedCity() {
    this.spinner.show();
    this.service.getZoneCity(this.selectedzoneName).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        console.log('res', res);
        this.cityDetails = res;
        this.cityQuery = '';
        this.selectedcityName = '';
        this.filteredcityDetails = this.cityDetails;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  onSelectedCampus() {
    this.spinner.show();
    this.service.getcityCampus(this.selectedcityId).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        console.log('res', res);
        this.campusDetails = res;
        this.campusQuery = '';
        this.selectedcampusName = '';
        this.filteredcampusDetails = this.campusDetails;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  // onSelectedBuilding() {
  //   this.spinner.show();
  //   this.service.getcitybuilding(this.selectedcampusId).subscribe({
  //     next: (res: any) => {
  //       if (!res) {
  //         this.spinner.hide();
  //         return;
  //       }
  //       console.log('res', res);
  //       this.buildingDetails = res;
  //       this.buildingQuery = '';
  //       this.filteredbuildingDetails = this.buildingDetails;
  //       this.spinner.hide();
  //     },
  //     error: (err: any) => {
  //       this.spinner.hide();
  //     }
  //   })
  // }

  // input Search //

  stateSearch(item: any) {
    this.stateValue = (item.target as HTMLInputElement).value;
    if (this.stateValue) {
      this.filteredStateDetails = this.stateDetails.filter((state: any) =>
        state.stateName.includes(this.stateValue) ||
        state.stateName.toLowerCase().includes(this.stateValue.toLowerCase())
      );
    } else {
      this.filteredStateDetails = this.stateDetails;
    }
  }

  zoneSearch(item: any) {
    this.zoneValue = (item.target as HTMLInputElement).value;
    if (this.zoneValue) {
      this.filteredZoneDetails = this.zoneDetails.filter((zone: any) =>
        zone.zoneName.includes(this.zoneValue) ||
        zone.zoneName.toLowerCase().includes(this.zoneValue.toLowerCase())
      );
    } else {
      this.filteredZoneDetails = this.zoneDetails;
    }
  }

  citySearch(item: any) {
    this.cityValue = (item.target as HTMLInputElement).value;
    if (this.cityValue) {
      this.filteredcityDetails = this.cityDetails.filter((city: any) =>
        city.cityName.includes(this.cityValue) ||
        city.cityName.toLowerCase().includes(this.cityValue.toLowerCase())
      );
    } else {
      this.filteredcityDetails = this.cityDetails;
    }
  }

  campusSearch(item: any) {
    this.campusValue = (item.target as HTMLInputElement).value;
    if (this.campusValue) {
      this.filteredcampusDetails = this.campusDetails.filter((campus: any) =>
        campus.campusName.includes(this.campusValue) ||
        campus.campusName.toLowerCase().includes(this.campusValue.toLowerCase())
      );
    } else {
      this.filteredcampusDetails = this.campusDetails;
    }
  }

  // buildingSearch(item: any) {
  //   this.buildingValue = (item.target as HTMLInputElement).value;
  //   if (this.buildingValue) {
  //     this.filteredbuildingDetails = this.buildingDetails.filter((building: any) =>
  //       building.buildingName.includes(this.buildingValue) ||
  //       building.buildingName.toLowerCase().includes(this.buildingValue.toLowerCase())
  //     );
  //   } else {
  //     this.filteredbuildingDetails = this.buildingDetails;
  //   }
  // }


  //End input Search //

  // campusData(data: any) {
  //   this.Datapassing = data;
  // }
  // stateData(data: any) {
  //   this.Datapassing = data;
  // }
  // zoneData(data: any) {
  //   this.Datapassing = data;
  // }
  // cityData(data: any) {
  //   this.Datapassing = data;
  // }


  campusData(data: any) {
    this.Datapassing = { type: 'campus', ...data };
  }

  stateData(data: any) {
    this.Datapassing = { type: 'state', ...data };
  }

  zoneData(data: any) {
    this.Datapassing = { type: 'zone', ...data };
  }

  cityData(data: any) {
    this.Datapassing = { type: 'city', ...data };
  }


  close() {
    this.dialogRef.close();
  }


  Search() {
    if (!this.Datapassing) {
      this.toast.showWarning('Please select state  to search');
    } else {
      this.dialogRef.close(this.Datapassing);
    }
  }

}
